import React from 'react';
import DropModal from 'components/shared/DropModal/DropModal';
import { PerfectScrollbar } from 'components/shared/ReactPerfectScrollbar';
import { LOADING_CIRCLE, USER_PREFERENCE_SETS } from 'common/utils/constants';
import { IconLoader } from 'common/IconLoader';
import SvgAF from 'components/shared/SvgAF/SvgAF';
import '../../FiltersBar.css';

const FilterSelectionDropdown = (props) => {
  const filterSets = Array.isArray(props.filterPreferences)
    ? props.filterPreferences.filter((pref) => pref.category === USER_PREFERENCE_SETS.FILTER_SET)
    : [];
  let overlay = null;
  // @todo use loading
  if (props.filterPreferencesLoading) {
    overlay = <div className="Global_LoadingCircle_Overlay">{LOADING_CIRCLE}</div>;
  }
  let filterDropdownTitle = (
    <div>
      <SvgAF img={IconLoader.icon_threeV} hover={IconLoader.icon_threeV_hover} />
    </div>
  );
  let index = 0;

  return (
    <div className="FiltersBar_DropdownContainer">
      <DropModal title={filterDropdownTitle} name={'selectFilterSet'}>
        <div className="FiltersSelectedPreference">
          <PerfectScrollbar>
            {overlay}
            <div className="FilterSelectedPreference_Save" onClick={props.saveFilterSelectionOnClick}>
              <div className="FilterSelectedPreference_Icon">
                <SvgAF img={IconLoader.icon_save_set} hover={IconLoader.icon_save_set} />
              </div>
              Save the filter selection as
            </div>
            <div className="FilterSelectedPreference_Seperator"></div>
            <div className="FilterSelectedPreference_Header">Choose from your saved filter sets</div>
            {filterSets.map((item) => (
              <div
                className="FilterSelectedPreference_Item"
                key={index++}
                onClick={() => props.selectFilterSetOnClick(item)}
              >
                {item.name}
              </div>
            ))}
            <div className="FilterSelectedPreference_Item" onClick={() => props.selectFilterSetOnClick()}>
              No filters
            </div>
            <div className="FilterSelectedPreference_Seperator"></div>
            <div className="FilterSelectedPreference_Manage" onClick={props.manageFiltersOnClick}>
              <div className="FilterSelectedPreference_Icon">
                <SvgAF img={IconLoader.icon_manage_set} hover={IconLoader.icon_manage_set} />
              </div>
              Manage filter sets
            </div>
          </PerfectScrollbar>
        </div>
      </DropModal>
    </div>
  );
};

export default FilterSelectionDropdown;
